<template>
  <div
    v-if="category.category === $t('message.progressBar.usedWord')"
    class="d-flex flex-column progressBarPercentage_down--info"
  >
    <div class="d-flex container-lengths">
      <span class="primary--text font-weight-medium">{{ category.length }}</span
      >&nbsp;<span class="grey--text text--darken-2"
        >({{ category.percentage.toFixed(0) }}%)</span
      >
    </div>
    <span style="color: #9e9e9e" class="text-start category-name">
      {{ category.category }}
    </span>
  </div>
  <div
    v-else-if="category.category === $t('message.progressBar.estimatedWord')"
    class="d-flex flex-column progressBarPercentage_top--info progressBarPercentage_top--info-estimated"
  >
    <div class="d-flex container-lengths">
      <span class="font-weight-medium" style="color: #7081f9">{{
        category.length
      }}</span>
    </div>
    <span style="color: #9e9e9e" class="category-name">
      {{ category.category }}
    </span>
  </div>
  <div
    v-else-if="category.category === $t('message.progressBar.hiredWord')"
    class="d-flex flex-column progressBarPercentage_down--info progressBarPercentage_down--info-hired"
  >
    <div class="d-flex container-lengths">
      <span class="grey--text text--darken-2 font-weight-medium">{{
        category.length
      }}</span>
    </div>
    <span style="color: #9e9e9e" class="category-name">
      {{ category.category }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'ProgressBarPercentage',
  props: {
    category: {
      required: true,
    },
  },
}
</script>

<style scoped>
.progressBarPercentage_down--info {
  position: absolute;
  color: black;
  top: 20px;
  font-size: 12px !important;
}

.progressBarPercentage_top--info {
  position: absolute;
  color: black;
  bottom: 20px;
  font-size: 12px !important;
}

.progressBarPercentage_down--info-hired {
  right: 0;
}

.container-lengths,
.category-name {
  white-space: nowrap;
}
</style>
